import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = `${URLS.URL_PRD}/enterprises`

const enterprisesAPI = {

 getEnterprises: async () => {
   const url = `${BASE_URL}`
   const { data } = await Axios.get(url)
   return data.enterprises
 },

 createEnterprise: async (name, ruc) => {
  const body = {
    enterprise: {
      name,
      ruc,
      description: ''
    }
  }
  const { data } = await Axios.post(BASE_URL, body)
  return data.enterprise[0]
 },

 updateEnterprise: async (id, name, ruc) => {
   const body = {
    enterprise: {
       name,
       ruc
     }
   }
   await Axios.put(`${BASE_URL}/${id}`, body)
 },

 deleteEnterprise: async id => {
  await Axios.delete(`${BASE_URL}/${id}`)
 }

}

export default enterprisesAPI
